import Axios from "axios"
import config from "../app.config"

export var settingsService;
export default settingsService = {
  getSettings,
  showSettings,
  updateSettings,
  createSettings,
  deleteSettings,
  getListSettings,
  getUploadMaxFileSize
}
async function getSettings(payload) {
  return await Axios.get(`${config.LOCAL_API_URL}/settings`, { params: payload })
    .then(response => {
      if (response.data.success || response.data.status) return Promise.resolve(response.data)
      else return Promise.reject(response.data)
    })
    .catch(error => {
      return Promise.reject(error);
    })
}
async function showSettings(id) {
  return await Axios.get(`${config.LOCAL_API_URL}/settings/` + id)
    .then(response => {
      if (response.data.success || response.data.status) return Promise.resolve(response.data)
      else return Promise.reject(response.data)
    })
    .catch(error => {
      return Promise.reject(error.response.data);
    })
}
async function updateSettings(data) {
  return await Axios.put(`${config.LOCAL_API_URL}/settings/` + data.id, data)
    .then(response => {
      if (response.data.success || response.data.status) return Promise.resolve(response.data)
      else return Promise.reject(response.data)
    })
    .catch(error => {
      return Promise.reject(error.response.data);
    })
}
async function deleteSettings(params) {
  return await Axios.delete(`${config.LOCAL_API_URL}/settings`, { data: params })
    .then(response => {
      if (response.data.success || response.data.status) return Promise.resolve(response.data)
      else return Promise.reject(response.data)
    })
    .catch(error => {
      return Promise.reject(error.response.data);
    })
}
async function createSettings(params) {
  return await Axios.post(`${config.LOCAL_API_URL}/settings`, params)
    .then(response => {
      if (response.data.success || response.data.status) return Promise.resolve(response.data)
      else return Promise.reject(response.data)
    })
    .catch(error => {
      return Promise.reject(error.response.data);
    })
}
async function getListSettings(data) {
  return await Axios.get(`${config.LOCAL_API_URL}/getListSettings`)
    .then(response => {
      if (response.data) {
        return Promise.resolve(response.data);
      } else {
        return Promise.reject(response);
      }
    }).catch(error => {
      return Promise.reject(error);
    })
}
async function getUploadMaxFileSize(data) {
  return await Axios.get(`${config.LOCAL_API_URL}/get-upload-max-file-size`)
    .then(response => {
      if (response.data.success || response.data.status) return Promise.resolve(response.data)
      else return Promise.reject(response)
    })
    .catch(error => {
      return Promise.reject(error.response.data);
    })
}